import common from "./common.en.json";

const translations = { common };

export default translations;
